<template>
  <div class="htmlBox">
    <div class="userinfo">
      <ul>
        <li>
          <p>手机号</p>
          <input type="tel" :disabled="bind_user_name != ''" placeholder="请输入手机号" v-model="phone" />
        </li>
        <li>
          <p>图片验证码</p>
          <input class="w200" type="num" placeholder="请输入图片验证码 " v-model="imgcode" />
          <img :src="codeImage" @click="getCaptcha" alt />
        </li>
        <li>
          <p>短信验证码</p>
          <input class="w200" type="num" name id value placeholder="请输入短信验证码 " v-model="code" />
          <em @click="getcode()" v-if="sign == false">发送验证码</em>
          <em v-else style="background:#BBBBBB;color:#fff ">{{ codehtml }}S</em>
        </li>
      </ul>
    </div>
    <button :disabled="btnState == false" :class="{ btnBg: btnState }" @click="sure()">绑定</button>

    <div class="zzc" v-if="isChangeIte">
      <div class="wxts">
        <div class="content">
          <div class="title">温馨提示</div>
          <div class="text">
            该手机号已被
            <span>{{bind_user_name}}</span>绑定，请更换手机号；或进行换绑，换绑后将为您解除原绑定关系，可能导致原账号无法找回。
          </div>
        </div>
        <div class="operating">
          <div @click="shutDown()">关闭</div>
          <div class="content_true" @click="changeTie()">换绑</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendRequest } from '@/assets/public'
import { Toast } from 'vant'
import urlconfig from '@/config.js'

export default {
  data() {
    return {
      phone: '', //手机号
      code: '', //验证码
      sign: false, //是否点击获取验证码按钮
      time: '', //倒计时
      isClick: false,
      codehtml: '',
      isMobile: false, //是否是手机号验证码登录
      onceCode: '', // 唯一code
      imgcode: '',
      codeImage: null, // 图形验证码
      imgKey: '', // 图片验证码的key
      isCodeTimes: true,
      isChangeIte: false, // 是否是换绑

      user_name: '', // 账号
      b2bpwd: '', // 密码
      bind_user_name: '', //被绑定时的user提示
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      hidshow: true //显示或者隐藏footer
    }
  },
  created() {
    this.getCaptcha()
    this.user_name = this.$router.history.current.query.user_name
    this.b2bpwd = this.$router.history.current.query.b2bpwd
    console.log(this.user_name, this.b2bpwd)
  },
  methods: {
    async getCaptcha() {
      if (!this.isCodeTimes) {
        return
      }
      this.isCodeTimes = false
      console.log('----------------')
      let res = await sendRequest('user/getCaptcha', {})
      if (res.status == 200) {
        this.codeImage = res.content.img
        this.imgKey = res.content.key
        setTimeout(() => {
          this.isCodeTimes = true
        }, 500)
      }
    },
    // 获取验证码  code与无code
    async getcode() {
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast('手机号码有误')
        return false
      } else {
        let path = 'user/sendNoCodeSms'

        if (this.imgcode == '') {
          Toast('请输入图形验证码')
          return
        }
        let params = {
          phone_mob: this.phone,
          captcha_code: this.imgcode,
          key: this.imgKey,
          code: this.onceCode,
          sms_type: !this.bind_user_name ? 7 : 2
        }
        let res = await sendRequest(path, params)
        console.log(res)
        if (res.status == 200) {
          this.codehtml = 60
          this.sign = true
          let tim = setInterval(() => {
            this.codehtml = this.codehtml - 1
            if (this.codehtml <= 0) {
              clearInterval(tim)
              this.sign = false
              return false
            }
          }, 1000)
          this.time = tim
        } else if (res.status == 2370) {
          this.bind_user_name = res.content.user_name
          this.isChangeIte = true
        } else {
          Toast(res.msg)
        }
      }
    },
    // 关闭
    shutDown() {
      this.bind_user_name = ''
      this.getCaptcha()
      this.imgcode = ''
      this.isChangeIte = false
    },
    // 确定
    changeTie() {
      this.getCaptcha()
      this.imgcode = ''
      this.isChangeIte = false
    },
    // 无code手机号验证码登录
    async sure() {
      if (this.isClick == false) {
        let tips = null
        if (this.phone == '') {
          tips = '请输入手机号'
        } else if (this.code == '') {
          tips = '请输入短信验证码'
        } else if (this.imgcode == '') {
          tips = '请输入图片验证码'
        }
        if (tips) {
          Toast(tips)
          return
        }
        let res = {}
        if (this.bind_user_name) {
          res = await sendRequest('user/changeMobileH5', {
            phone_mob: this.phone,
            sms_code: this.code,
            user_name: this.user_name,
            b2bpwd: this.b2bpwd
          })
        } else {
          res = await sendRequest('user/relationMemberH5', {
            phone_mob: this.phone,
            sms_code: this.code,
            user_name: this.user_name,
            b2bpwd: this.b2bpwd
          })
        }

        if (res.status != 200) {
          Toast(res.msg)
          this.isClick = false
        } else {
          this.isClick = true
          Toast('登录成功')
          localStorage.setItem('token', res.content.token)
          localStorage.setItem('infor', JSON.stringify(res.content))
          setTimeout(() => {
            this.$router.push({ path: '/personalCenter' })
          }, 2000)
        }
      }
    }
  },
  computed: {
    btnState() {
      //当用户名和密码框都不为空时btnState==true,利用这个计算属性来动态控制按钮的禁用和颜色
      return this.phone !== '' && this.code !== ''
    }
  }
}
</script>
<style scoped>
.msgLogin {
  width: 13.6rem;
  height: 2rem;
  line-height: 2rem;
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 50px;
  background: #fff;
  color: #333;
  font-size: 0.6rem;
}

/* ------ 底部 ------ */
.foot_box {
  width: 100vw;
  position: fixed;
  bottom: 0.5rem;
  left: 0;
}

.footer {
  width: 15rem;
  text-align: center;
}

.footer_tips {
  text-align: center;
  font-size: 0.48rem;
  color: rgba(153, 153, 153, 1);
  margin-bottom: 0.4rem;
}

.xieyi {
  margin-top: 0.5rem;
  width: 100%;
  font-size: 0.46rem;
  text-align: center;
  color: rgba(51, 51, 51, 1);
}

.xieyi .iconfont {
  margin-right: 0.3rem;
}

.xieyi b {
  color: #fd3e3e;
}

/* ------ end 底部 ------ */

.checkLogin {
  color: #333333;
  font-size: 0.48rem;
  width: 13.6rem;
  margin-left: 0.7rem;
  text-align: center;
  line-height: 2rem;
  color: #fd3e3e;
}

/*button禁用时的背景颜色*/
button {
  width: 13.6rem;
  height: 2rem;
  background: rgba(221, 221, 221, 1);
  border-radius: 50px;
  margin-left: 0.7rem;
  line-height: 2rem;
  font-size: 0.6rem;
  margin-top: 0.8rem;
  color: #fff;
  border: none;
}

/*button可用时的背景颜色*/
.btnBg {
  width: 13.6rem;
  height: 2rem;
  border-radius: 50px;
  margin-left: 0.7rem;
  line-height: 2rem;
  font-size: 0.6rem;
  color: #fff;
  background: #fd3e3e;
  margin-top: 0.8rem;
  border: none;
}

.htmlBox {
  height: 100vh;
  display: block;
  /* background: #fff url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/loin_img.png') no-repeat center top; */
  /* background-size: 15rem 6.54rem; */

  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  overflow: hidden;
}

.userinfo {
  width: 15rem;
  padding-top: 8rem;
}

.userinfo ul {
  padding: 0 0.8rem;
}

.userinfo ul li {
  height: 1.6rem;
  line-height: 1.6rem;
  border-bottom: 1px solid #eee;
  padding-top: 0.4rem;
}

.userinfo ul li:last-child {
  border-bottom: none;
}

.userinfo ul li p {
  float: left;
  font-size: 0.56rem;
  color: #333333;
  width: 3rem;
}

.userinfo ul li input {
  width: 8rem;
  float: left;
  border: none;
  font-size: 0.56rem;
  padding-left: 0.4rem;
  background: none;
}

.userinfo ul li img {
  display: block;
  width: 3.6rem;
  height: 1.4rem;
  float: right;
}

.userinfo ul li input.w200 {
  width: 6rem !important;
}

.userinfo ul li em {
  width: 3.6rem;
  height: 1.4rem;
  background: #fd3e3e;
  border-radius: 0.2rem;
  color: #fff;
  line-height: 1.4rem;
  float: right;
  font-size: 0.56rem;
  font-style: normal;
  text-align: center;
}

.sure_btn {
  width: 13.6rem;
  height: 2rem;
  background: rgba(221, 221, 221, 1);
  border-radius: 0.2rem;
  position: absolute;
  bottom: 1.6rem;
  left: 0.7rem;
  line-height: 2rem;
  font-size: 0.6rem;
  color: #fff;
}

.active {
  background: #fd3e3e !important;
}

/* 换绑提示 */
.zzc {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
}

.wxts {
  width: 12.4rem;
  height: auto;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.2rem;
}

.title {
  font-size: 0.68rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-top: 0.8rem;
  text-align: center;
  margin-bottom: 1rem;
}

.content {
  padding: 0 1rem 0.9rem;
  background: #fff;
  border-bottom: 1px solid #dddddd;
}

.text {
  font-size: 0.56rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 0.7rem;
}

.text span {
  color: #fd3e3e;
}

.operating {
  display: flex;
  justify-content: space-between;
  height: 2rem;
}

.operating div {
  width: 50%;
  box-sizing: border-box;
  font-size: 0.68rem;
  color: rgba(153, 153, 153, 1);
  line-height: 2rem;
  text-align: center;
}

.operating .content_true {
  border-left: 1px solid #dddddd;
  color: #fd3e3e;
}
</style>